import { render } from "./create-batch.vue?vue&type=template&id=37e186cd"
import script from "./create-batch.vue?vue&type=script&lang=js"
export * from "./create-batch.vue?vue&type=script&lang=js"
script.render = render

export default script